/* eslint-disable no-param-reassign */
import produce from "immer";
import actionTypes from "../Actions/types";

export const DEFAULT_LIGHT_THEME = {
    isAuto: false,
    label: "light",
    mode: "light",
    v: 2,
};

const initialState = {
    theme: { ...DEFAULT_LIGHT_THEME },
    currency: "USDT",
    timezone: "Asia/Kolkata",
    lastBackup: 0,
    syncStatus: "idle",
    defaultSortBy: "currentValue",
    hideSmallBalances: false,
    hideExitedPositions: false,
    binanceTimeRange: 7,
    binanceCurrency: "USDT",
    binanceSortBy: "currentValue",
    binanceCutoffDate: "2026-01-01",
};

const normalizeThemePayload = (themePayload) => {
    if (!themePayload || typeof themePayload !== "object") {
        return { ...DEFAULT_LIGHT_THEME };
    }
    const isAuto = Boolean(themePayload.isAuto || themePayload.mode === "auto");
    const label =
        themePayload.label === "dark" || themePayload.mode === "dark"
            ? "dark"
            : "light";
    return {
        ...themePayload,
        isAuto,
        label,
        mode: isAuto ? "auto" : label,
        v: 2,
    };
};

const reducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {
            case "persist/REHYDRATE": {
                const incoming = action.payload?.settings;
                if (incoming && typeof incoming === "object") {
                    Object.keys(incoming).forEach((key) => {
                        if (
                            key !== "theme" &&
                            key !== "syncStatus" &&
                            incoming[key] !== undefined
                        ) {
                            draft[key] = incoming[key];
                        }
                    });
                    if (incoming.theme && incoming.theme.v === 2) {
                        draft.theme = normalizeThemePayload(incoming.theme);
                    } else {
                        draft.theme = { ...DEFAULT_LIGHT_THEME };
                    }
                    draft.syncStatus = "idle";
                }
                break;
            }
            case actionTypes.UPDATE_SETTINGS: {
                const payload = action.payload || {};
                if (payload.theme !== undefined) {
                    draft.theme = normalizeThemePayload(payload.theme);
                }
                if (payload.lastBackup !== undefined) {
                    draft.lastBackup = payload.lastBackup;
                }
                if (payload.syncStatus !== undefined) {
                    draft.syncStatus = payload.syncStatus;
                }
                if (payload.currency !== undefined) {
                    draft.currency = payload.currency;
                }
                if (payload.timezone !== undefined) {
                    draft.timezone = payload.timezone;
                }
                if (payload.currencyExchangeRate !== undefined) {
                    draft.currencyExchangeRate = payload.currencyExchangeRate;
                }
                if (payload.defaultSortBy !== undefined) {
                    draft.defaultSortBy = payload.defaultSortBy;
                }
                if (payload.hideSmallBalances !== undefined) {
                    draft.hideSmallBalances = Boolean(
                        payload.hideSmallBalances
                    );
                }
                if (payload.hideExitedPositions !== undefined) {
                    draft.hideExitedPositions = Boolean(
                        payload.hideExitedPositions
                    );
                }
                if (payload.binanceTimeRange !== undefined) {
                    draft.binanceTimeRange = payload.binanceTimeRange;
                }
                if (payload.binanceCurrency !== undefined) {
                    draft.binanceCurrency = payload.binanceCurrency;
                }
                if (payload.binanceSortBy !== undefined) {
                    draft.binanceSortBy = payload.binanceSortBy;
                }
                if (payload.binanceCutoffDate !== undefined) {
                    draft.binanceCutoffDate = payload.binanceCutoffDate;
                }
                break;
            }
            case actionTypes.UPDATE_THEME:
                draft.theme = normalizeThemePayload(action.payload);
                break;
            case actionTypes.UPDATE_LAST_BACKUP:
                draft.lastBackup = action.payload;
                break;
            case actionTypes.UPDATE_SYNC_STATUS:
                draft.syncStatus = action.payload || "idle";
                break;
            default:
                return draft;
        }
    });
export default reducer;
